import React, {useEffect, useRef, useState} from 'react';
import {
  SafeAreaView,
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
  Alert,
  ActivityIndicator,
  Platform,
  ScrollView,
  FlatList,
  Dimensions,
  Linking,
  Animated,
  Modal,
  TextInput,
  Share,
} from 'react-native';
import {useRoute, useNavigation} from '@react-navigation/native';
import {SCREENS} from '~constants';
import {RouteProp} from '@react-navigation/native';
import {NavigationProps, RootStackParamsList} from '~types/navigation/navigation.type';
import moment from 'moment';
import {LONG_DATE_FORMAT} from '~Utils/Time';
import {useGetOrderById} from '~hooks/event/useGetOrderById';
import {useGetEventById} from '~hooks/event/useGetEventById';
import QRCodeGenerator from '~components/QR-codes/QRCodeGenerator';
import {useGetUserAccount} from '~hooks/user/useGetUser';
import {useUserStore} from '~providers/userStore/zustand';
import {useCancelOrder} from '~hooks/event/useCancelOrder';
import {Notifier, NotifierComponents} from 'react-native-notifier';
import {useDeleteUserEventStatus} from '~hooks/event/useDeleteUserEventStatus';
import StarIcon from '~assets/icons/StarIcon';
import {useTheme} from '~contexts/ThemeContext';
import {ThemedStatusBar} from '~components/ThemedStatusBar';
import {ModernHeader} from '~components/ModernHeader';
import {useGetOrderFinalAddress} from '~hooks/event/useGetOrderFinalAddress';
import {PERMISSIONS, RESULTS, check, request, openSettings} from 'react-native-permissions';
import * as AddCalendarEvent from 'react-native-add-calendar-event';
import RNCalendarEvents from 'react-native-calendar-events';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import TransferBookingModal from '~components/TransferBookingModal/TransferBookingModal';
import {useOnTimeStatus, useLateStatus, useNotComingStatus} from '~hooks/order/useAttendanceStatus';
import { useSetAttendanceStatus } from '~hooks/order/useSetAttendanceStatus';
import { useGetAttendanceStatus } from '~hooks/order/useGetAttendanceStatus';
import { useInviteGuestViaEmail } from '~hooks/guest/useInviteGuestViaEmail';
import { useGetGuestDetails } from '~hooks/guest/useGetGuestDetails';
import LinearGradient from 'react-native-linear-gradient';
// If you use react-native-paper, uncomment the next line:
// import { Divider } from 'react-native-paper';

// Or define a simple Divider component if you don't use a library:
const Divider = ({colors}: any) => <View style={{ height: 1, backgroundColor: colors.border, marginVertical: 8 }} />;

const screenWidth = Platform.OS == 'web' && Dimensions.get('window').width > 480 ? 480 : Dimensions.get('window').width;

const PaymentSuccess: React.FC = () => {
  const {colors} = useTheme();
  const DATE_FORMAT = 'ddd ' + LONG_DATE_FORMAT;
  const route = useRoute<RouteProp<RootStackParamsList, SCREENS.PAYMENT_SUCCESS>>();
  const navigation = useNavigation<NavigationProps>();
  const {eventId, selectedTickets, order_id, fromNotifications} = route.params;

  const [qrValue, setQrValue] = useState<string>('');
  const [countdownTime, setCountdownTime] = useState<string>('');
  const pulseAnim = useRef(new Animated.Value(1)).current;
  const addressPulseAnim = useRef(new Animated.Value(1)).current;
  const rateButtonAnim = useRef(new Animated.Value(1)).current;
  const rateCardScale = useRef(new Animated.Value(0.95)).current;
  const rateCardOpacity = useRef(new Animated.Value(0)).current;
  const {data: orderDetails, isLoading, refetch} = useGetOrderById(order_id);
  const user = useUserStore(state => state.user);
  const {data: userAccount} = useGetUserAccount(user?.uid || '');
  const {data: eventData, isLoading: eventLoading} = useGetEventById(orderDetails?.event_id);
  const {mutate: cancelOrder, isLoading: cancelLoading} = useCancelOrder();
  const {mutateAsync: deleteEventUserStatus, isLoading: cancelFreeLoading} = useDeleteUserEventStatus();
  const {data: finalAddressData, isLoading: finalAddressLoading} = useGetOrderFinalAddress(order_id);
  const flatListRef = useRef<any>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [transferModalVisible, setTransferModalVisible] = useState(false);
  const [transferCancelOptionsVisible, setTransferCancelOptionsVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<'on_time' | 'late' | 'not_coming' | null>(null);

  
  console.log(orderDetails, 'orderDetailsorderDetails');
  
  // Attendance status hooks
  const {mutate: updateOnTimeStatus, isLoading: onTimeLoading} = useOnTimeStatus();
  const {mutate: updateLateStatus, isLoading: lateLoading} = useLateStatus();
  const {mutate: updateNotComingStatus, isLoading: notComingLoading} = useNotComingStatus();

  const { mutate: setAttendanceStatus, isLoading: attendanceLoading } = useSetAttendanceStatus();
  const { data: attendanceStatusData, isLoading: attendanceStatusLoading } = useGetAttendanceStatus(order_id);
  
  // Guest invitation hooks
  const {mutateAsync: inviteGuestViaEmail, isLoading: isInviting} = useInviteGuestViaEmail();
  const {data: guestDetails = [], isLoading: guestDetailsLoading} = useGetGuestDetails(orderDetails?.guest_uids || []);

   // Guest invitation state
  const [inviteModalVisible, setInviteModalVisible] = useState(false);
  const [emailInviteModalVisible, setEmailInviteModalVisible] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteName, setInviteName] = useState('');

  
  // Cancel booking states
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [cancelReason, setCancelReason] = useState('');
  
  const styles = StyleSheet.create({
    button: {
      flex: 1,
      marginHorizontal: 4,
      maxWidth: '48%', // Prevent buttons from stretching too wide
    },
    cancellationLink: {
      paddingVertical: 0,
      paddingHorizontal: 0,
      borderRadius: 0,
      alignSelf: 'flex-start',
      backgroundColor: 'transparent',
    },
    cancellationLinkText: {
      fontSize: 14,
      color: colors.primary,
      textDecorationLine: 'underline',
      fontWeight: '500',
    },
    // Attendance Status styles
    attendanceContainer: {
      backgroundColor: colors.white,
      borderBottomWidth: 1,
      borderColor: colors.border,
      marginTop: 16,
    },
    attendanceHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderColor: colors.border,
    },
    attendanceTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
      marginLeft: 8,
    },
    attendanceContent: {
      paddingHorizontal: 16,
      paddingVertical: 16,
    },
    attendanceDescription: {
      fontSize: 14,
      color: colors.textSecondary,
      lineHeight: 20,
      marginBottom: 16,
    },
    attendanceButton: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.surface,
      paddingVertical: 14,
      paddingHorizontal: 16,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: colors.border,
      marginVertical: 6,
    },
    attendanceButtonActive: {
      borderWidth: 2,
    },
    attendanceButtonOnTime: {
      borderColor: colors.statusGreen,
      backgroundColor: colors.statusGreen + '10',
    },
    attendanceButtonLate: {
      borderColor: colors.warning,
      backgroundColor: colors.warning + '10',
    },
    attendanceButtonNotComing: {
      borderColor: colors.error,
      backgroundColor: colors.error + '10',
    },
    attendanceButtonText: {
      fontSize: 15,
      fontWeight: '600',
      color: colors.textPrimary,
      marginLeft: 8,
    },
    attendanceButtonTextActive: {
      fontWeight: '700',
    },
    attendanceModalOverlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'flex-end',
    },
    attendanceModalContainer: {
      backgroundColor: colors.white,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      paddingBottom: 32,
      paddingTop: 8,
    },
    attendanceModalHandle: {
      width: 40,
      height: 4,
      borderRadius: 2,
      backgroundColor: colors.border,
      alignSelf: 'center',
      marginBottom: 16,
    },
    attendanceModalTitle: {
      fontSize: 18,
      fontWeight: '700',
      color: colors.textPrimary,
      textAlign: 'center',
      marginBottom: 16,
      paddingHorizontal: 16,
    },
    attendanceOptionButton: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 16,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    attendanceOptionIcon: {
      fontSize: 24,
      width: 32,
      textAlign: 'center',
      marginRight: 16,
    },
    attendanceOptionTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
    },
    attendanceOptionDescription: {
      fontSize: 14,
      color: colors.textSecondary,
      marginTop: 4,
    },
    attendanceStatusBadge: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 4,
      marginTop: 8,
    },
    attendanceStatusBadgeText: {
      fontSize: 14,
      fontWeight: '500',
      marginLeft: 4,
    },
    addToWalletText: {
      color: colors.white,
      fontWeight: '600',
      fontSize: 14,
    },
    cancelButtonText: {
      color: colors.white,
      fontWeight: '600',
      fontSize: 14,
    },
    navigationContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 12,
      marginTop: 16,
      marginBottom: 8,
    },
    pageIndicator: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    navButton: {
      paddingVertical: 10,
      paddingHorizontal: 16,
      backgroundColor: colors.primary,
      borderRadius: 6,
    },
    navButtonDisabled: {
      backgroundColor: colors.gray200 || '#ccc',
      opacity: 0.5,
    },
    navButtonText: {
      color: colors.white,
      fontWeight: '600',
      fontSize: 14,
    },
    navButtonTextDisabled: {
      color: colors.gray400 || '#999',
    },
    ticketContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 20,
    },
    ticketTitle: {
      fontSize: 18,
      fontWeight: '700',
      marginBottom: 24,
      textAlign: 'center',
      color: colors.textPrimary,
      letterSpacing: 0.3,
    },
    ticketSection: {
      backgroundColor: colors.surface,
      borderRadius: 16,
      paddingVertical: 24,
      marginVertical: 16,
      shadowColor: colors.textPrimary,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.08,
      shadowRadius: 8,
      elevation: 6,
    },
    loaderContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 100,
      backgroundColor: colors.overlayBackground,
      minHeight: Dimensions.get('window').height,
    },
    statusContainer: {
      paddingHorizontal: 16,
      paddingVertical: 12,
      backgroundColor: colors.surface,
      borderBottomWidth: 0,
      marginHorizontal: 16,
      marginTop: 12,
      borderRadius: 12,
      marginBottom: 8,
    },
    statusHeader: {
      fontSize: 18,
      fontWeight: '800',
      color: colors.statusGreen,
      marginBottom: 3,
      letterSpacing: -0.3,
    },
    statusDescription: {
      fontSize: 14,
      lineHeight: 18,
      color: colors.textSecondary,
    },
    statusIcon: {
      fontSize: 24,
      marginBottom: 8,
    },
    statusBadge: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.statusGreen + '15',
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 4,
      alignSelf: 'flex-start',
      marginTop: 12,
    },
    statusBadgeText: {
      fontSize: 14,
      color: colors.statusGreen,
      fontWeight: '500',
      marginLeft: 4,
    },
    cancelTicketButton: {
      backgroundColor: colors.error, // Red color for cancellation
      paddingVertical: 15,
      borderRadius: 10,
      alignItems: 'center',
      marginHorizontal: 15,
      marginTop: 10, // Add some spacing from the wallet button
    },
    cancelIcon: {
      tintColor: colors.white,
      width: 24,
      height: 24,
      marginRight: 10,
    },
    walletIcon: {
      tintColor: colors.white,
      width: 24,
      height: 24,
      marginRight: 10,
    },
    borderView: {
      borderColor: colors.border,
      borderBottomWidth: 1,
      marginBottom: 10,
    },
    container: {flex: 1, backgroundColor: colors.background},
    backButton: {
      padding: 10,
      margin: 10,
      alignSelf: 'flex-start',
    },
    sectionSeparator: {
      height: 8,
      backgroundColor: colors.surface,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    eventDetails: {
      paddingHorizontal: 16,
      backgroundColor: colors.white,
      paddingTop: Platform.OS === 'ios' ? 16 : 40,
      borderColor: colors.border,
      borderBottomWidth: 1,
      paddingVertical: 12,
    },
    eventCardWrapper: {
      backgroundColor: colors.surface,
      borderRadius: 16,
      overflow: 'hidden',
      shadowColor: colors.textPrimary,
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.06,
      shadowRadius: 8,
      elevation: 5,
    },
    eventHeaderContainer: {
      paddingHorizontal: 16,
      paddingBottom: 16,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    eventImage: {
      width: '100%',
      height: 200,
      borderRadius: 16,
      marginBottom: 0,
      backgroundColor: colors.surface,
    },
    eventImageContainer: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 18,
      backgroundColor: colors.surface,
    },
    eventInfo: {
      paddingHorizontal: 14,
      paddingVertical: 12,
      paddingTop: 0,
    },
    eventTitle: {
      fontSize: 20,
      fontWeight: '800',
      color: colors.textPrimary,
      marginBottom: 10,
      letterSpacing: -0.2,
      lineHeight: 28,
    },
    eventLocation: {
      fontSize: 15,
      color: colors.textSecondary,
      marginBottom: 12,
      lineHeight: 20,
    },
    dateContainer: {
      backgroundColor: colors.primary + '08',
      borderRadius: 12,
      paddingVertical: 10,
      paddingHorizontal: 12,
      marginBottom: 10,
      borderLeftWidth: 3,
      borderLeftColor: colors.primary,
    },
    dateHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 8,
    },
    dateIcon: {
      marginRight: 8,
      color: colors.primary,
    },
    dateTitle: {
      fontSize: 15,
      fontWeight: '600',
      color: colors.textPrimary,
    },
    dateRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 4,
    },
    dateLabel: {
      fontSize: 14,
      color: colors.textSecondary,
      width: 50,
    },
    dateText: {
      fontSize: 14,
      color: colors.textPrimary,
      flex: 1,
    },
    calendarButton: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.primary + '15',
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderRadius: 6,
      marginTop: 8,
    },
    calendarButtonText: {
      fontSize: 14,
      color: colors.primary,
      fontWeight: '500',
      marginLeft: 6,
    },
    ticketList: {
      backgroundColor: colors.white,
      marginTop: 16,
      paddingBottom: 16,
      borderTopWidth: 8,
      borderBottomWidth: 8,
      borderColor: colors.surface,
    },
    ticketListHeader: {
      paddingHorizontal: 16,
      paddingVertical: 12,
      backgroundColor: colors.white,
      borderColor: colors.border,
    },
    ticketListHeaderText: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
    },
    sectionDivider: {
      height: 8,
      backgroundColor: colors.surface,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    reviewItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 12,
      paddingHorizontal: 16,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    ticketItem: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingVertical: 12,
      paddingHorizontal: 16,
      borderColor: colors.border,
    },
    ticketItemLeft: {
      flex: 1,
    },
    ticketType: {
      fontSize: 15,
      fontWeight: '500',
      color: colors.textPrimary,
      marginBottom: 2,
    },
    ticketQuantity: {
      fontSize: 13,
      color: colors.textSecondary,
    },
    ticketPrice: {
      fontSize: 15,
      fontWeight: '600',
      color: colors.primary,
      textAlign: 'right',
    },
    totalSection: {
      marginTop: 8,
      paddingTop: 12,
      paddingHorizontal: 16,
      borderTopColor: colors.border,
    },
    totalRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingVertical: 4,
    },
    totalLabel: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
    },
    totalAmount: {
      fontSize: 18,
      fontWeight: '700',
      color: colors.primary,
    },
    qrContainer: {
      alignItems: 'center',
      paddingVertical: 24,
      backgroundColor: colors.surface,
      marginTop: 16,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    addToWalletButton: {
      backgroundColor: colors.eventInfluencer,
      paddingVertical: 15,
      borderRadius: 10,
      alignItems: 'center',
      marginHorizontal: 15,
      marginTop: 10, // Add some spacing from the wallet button
    },
    countdownSection: {
      backgroundColor: colors.white,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: colors.border,
      marginTop: 16,
    },
    countdownContainer: {
      paddingVertical: 16,
      paddingHorizontal: 16,
      backgroundColor: colors.white,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    countdownHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 12,
    },
    countdownIconContainer: {
      width: 32,
      height: 32,
      borderRadius: 16,
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: 12,
      backgroundColor: colors.primary + '10',
    },
    countdownContent: {
      flex: 1,
    },
    countdownTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
      marginBottom: 4,
    },
    countdownSubtitle: {
      fontSize: 14,
      color: colors.textSecondary,
      lineHeight: 20,
    },
    countdownTimer: {
      fontSize: 24,
      fontWeight: '700',
      color: colors.primary,
      textAlign: 'center',
      marginTop: 8,
      fontVariant: ['tabular-nums'],
    },
    countdownBadge: {
      paddingHorizontal: 6,
      paddingVertical: 2,
      borderRadius: 8,
      alignSelf: 'flex-start',
      marginTop: 4,
    },
    countdownBadgeText: {
      fontSize: 9,
      fontWeight: '400',
    },
    countdownStopwatch: {
      fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace',
      fontSize: 20,
      fontWeight: 'bold',
      letterSpacing: 1,
    },
    countdownStopwatchLarge: {
      fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace',
      fontSize: 28,
      fontWeight: 'bold',
      letterSpacing: 2,
      textAlign: 'center',
      borderRadius: 8,
    },
    addressSection: {
      backgroundColor: colors.surface,
      borderBottomWidth: 0,
      marginHorizontal: 16,
      marginTop: 10,
      borderRadius: 12,
      overflow: 'hidden',
      shadowColor: colors.textPrimary,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.05,
      shadowRadius: 4,
      elevation: 3,
    },
    addressContainer: {
      paddingVertical: 12,
      paddingHorizontal: 14,
    },
    addressHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 12,
    },
    addressIcon: {
      fontSize: 20,
      marginRight: 8,
      color: colors.primary,
    },
    addressContent: {
      flex: 1,
    },
    addressTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
      marginBottom: 4,
    },
    addressText: {
      fontSize: 14,
      color: colors.textSecondary,
      lineHeight: 20,
    },
    addressTimeInfo: {
      fontSize: 13,
      color: colors.primary,
      marginTop: 8,
      fontStyle: 'italic',
    },
    addressAlert: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.warning + '15',
      paddingHorizontal: 12,
      paddingVertical: 8,
      marginTop: 12,
      borderRadius: 4,
      borderLeftWidth: 2,
      borderLeftColor: colors.warning,
    },
    addressAlertText: {
      fontSize: 13,
      color: colors.warning,
      flex: 1,
      marginLeft: 8,
    },
    calendarHint: {
      fontSize: 12,
      color: colors.primary,
      fontStyle: 'italic',
      marginTop: 4,
    },
    buttonContainer: {
      paddingHorizontal: 16,
      paddingVertical: 12,
      backgroundColor: colors.background,
      borderTopWidth: 0,
      borderBottomWidth: 0,
    },
    primaryButton: {
      backgroundColor: colors.primary,
      paddingVertical: 12,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      borderRadius: 10,
      marginVertical: 5,
      shadowColor: colors.primary,
      shadowOffset: { width: 0, height: 3 },
      shadowOpacity: 0.15,
      shadowRadius: 6,
      elevation: 5,
    },
    secondaryButton: {
      backgroundColor: colors.surface,
      paddingVertical: 12,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      borderRadius: 10,
      marginVertical: 5,
      borderWidth: 0,
      shadowColor: colors.textPrimary,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.06,
      shadowRadius: 4,
      elevation: 3,
    },
    rateEventCard: {
      marginVertical: 8,
      marginHorizontal: 0,
      borderRadius: 14,
      overflow: 'hidden',
      backgroundColor: colors.surface,
      shadowColor: colors.primary,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.1,
      shadowRadius: 8,
      elevation: 8,
    },
    rateEventCardContent: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 14,
    },
    rateEventIconContainer: {
      width: 60,
      height: 60,
      borderRadius: 14,
      backgroundColor: colors.primary + '12',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 12,
    },
    rateEventTextContainer: {
      flex: 1,
      justifyContent: 'center',
    },
    rateEventTitle: {
      fontSize: 15,
      fontWeight: '800',
      color: colors.textPrimary,
      marginBottom: 2,
      letterSpacing: 0.2,
    },
    rateEventSubtitle: {
      fontSize: 12,
      fontWeight: '500',
      color: colors.textSecondary,
      letterSpacing: 0.1,
    },
    rateEventArrow: {
      marginLeft: 8,
      color: colors.primary,
    },
    dangerButton: {
      backgroundColor: colors.white,
      paddingVertical: 14,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      borderRadius: 4,
      marginVertical: 6,
      borderWidth: 1,
      borderColor: colors.error,
    },
    buttonText: {
      fontSize: 14,
      fontWeight: '700',
      marginLeft: 8,
      letterSpacing: 0.2,
    },
    primaryButtonText: {
      color: colors.white,
    },
    secondaryButtonText: {
      color: colors.textPrimary,
    },
    dangerButtonText: {
      color: colors.error,
    },
    buttonIcon: {
      width: 20,
      height: 20,
      tintColor: colors.white,
    },
    dangerButtonIcon: {
      width: 20,
      height: 20,
      tintColor: colors.error,
    },
    // Transfer/Cancel Options Modal Styles
    modalOverlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'center',
      alignItems: 'center',
    },
    modalContainer: {
      backgroundColor: colors.white,
      borderRadius: 16,
      margin: 20,
      padding: 24,
      minWidth: '80%',
      maxWidth: '90%',
    },
    modalHeader: {
      alignItems: 'center',
      marginBottom: 24,
    },
    modalTitle: {
      fontSize: 20,
      fontWeight: '700',
      color: colors.textPrimary,
      textAlign: 'center',
      marginBottom: 8,
    },
    modalSubtitle: {
      fontSize: 14,
      color: colors.textSecondary,
      textAlign: 'center',
      lineHeight: 20,
    },
    modalOptionsContainer: {
      gap: 12,
      marginBottom: 20,
    },
    modalOptionButton: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 16,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: colors.border,
      backgroundColor: colors.surface,
    },
    modalOptionButtonTransfer: {
      borderColor: colors.primary,
      backgroundColor: colors.primary + '10',
    },
    modalOptionButtonCancel: {
      borderColor: colors.error,
      backgroundColor: colors.error + '10',
    },
    modalOptionIcon: {
      marginRight: 12,
      width: 24,
      height: 24,
    },
    modalOptionContent: {
      flex: 1,
    },
    modalOptionTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
      marginBottom: 4,
    },
    modalOptionDescription: {
      fontSize: 13,
      color: colors.textSecondary,
      lineHeight: 18,
    },
    modalCancelButton: {
      padding: 16,
      alignItems: 'center',
      borderRadius: 8,
      backgroundColor: colors.surface,
      borderWidth: 1,
      borderColor: colors.border,
    },
    modalCancelButtonText: {
      fontSize: 16,
      fontWeight: '500',
      color: colors.textSecondary,
    },
    // Guest invitation styles
    guestSection: {
      backgroundColor: colors.white,
      marginTop: 16,
      paddingVertical: 16,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    guestSectionHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      marginBottom: 12,
    },
    guestSectionTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.textPrimary,
      marginLeft: 8,
    },
    guestItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderBottomWidth: 1,
      borderColor: colors.border,
    },
    guestInfo: {
      flex: 1,
      marginLeft: 12,
    },
    guestName: {
      fontSize: 15,
      fontWeight: '500',
      color: colors.textPrimary,
      marginBottom: 2,
    },
    guestEmail: {
      fontSize: 13,
      color: colors.textSecondary,
    },
    guestStatus: {
      fontSize: 12,
      fontWeight: '500',
      paddingHorizontal: 8,
      paddingVertical: 4,
      borderRadius: 4,
    },
    confirmedStatus: {
      backgroundColor: colors.statusGreen + '15',
      color: colors.statusGreen,
    },
    pendingStatus: {
      backgroundColor: colors.warning + '15',
      color: colors.warning,
    },
    inviteButton: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: colors.primary,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderRadius: 8,
      marginHorizontal: 16,
      marginTop: 12,
    },
    inviteButtonText: {
      color: colors.white,
      fontSize: 15,
      fontWeight: '600',
      marginLeft: 8,
    },
    inviteModalOverlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'center',
      alignItems: 'center',
    },
    inviteModalContainer: {
      backgroundColor: colors.white,
      borderRadius: 16,
      margin: 20,
      padding: 24,
      minWidth: '80%',
      maxWidth: '90%',
    },
    inviteModalTitle: {
      fontSize: 18,
      fontWeight: '700',
      color: colors.textPrimary,
      textAlign: 'center',
      marginBottom: 20,
    },
    inviteOptionButton: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 16,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: colors.border,
      backgroundColor: colors.surface,
      marginBottom: 12,
    },
    inviteOptionIcon: {
      marginRight: 12,
    },
    inviteOptionText: {
      fontSize: 16,
      fontWeight: '500',
      color: colors.textPrimary,
    },
    emailInviteModal: {
      backgroundColor: colors.white,
      borderRadius: 16,
      margin: 20,
      padding: 24,
      minWidth: '80%',
      maxWidth: '90%',
    },
    emailInviteTitle: {
      fontSize: 18,
      fontWeight: '700',
      color: colors.textPrimary,
      marginBottom: 20,
    },
    inputLabel: {
      fontSize: 14,
      fontWeight: '500',
      color: colors.textPrimary,
      marginBottom: 8,
    },
    textInput: {
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: 8,
      paddingHorizontal: 12,
      paddingVertical: 12,
      fontSize: 16,
      marginBottom: 16,
      backgroundColor: colors.white,
    },
    sendInviteButton: {
      backgroundColor: colors.primary,
      paddingVertical: 14,
      borderRadius: 8,
      alignItems: 'center',
      marginBottom: 12,
    },
    sendInviteButtonText: {
      color: colors.white,
      fontSize: 16,
      fontWeight: '600',
    },
    cancelInviteButton: {
      backgroundColor: colors.surface,
      paddingVertical: 14,
      borderRadius: 8,
      alignItems: 'center',
      borderWidth: 1,
      borderColor: colors.border,
    },
    cancelInviteButtonText: {
      color: colors.textSecondary,
      fontSize: 16,
      fontWeight: '500',
    },
    guestMessage: {
      backgroundColor: colors.statusBlue + '15',
      borderRadius: 8,
      padding: 12,
      marginHorizontal: 16,
      marginTop: 12,
      borderLeftWidth: 3,
      borderLeftColor: colors.statusBlue,
    },
    guestMessageText: {
      fontSize: 14,
      color: colors.statusBlue,
      lineHeight: 20,
    },
  });

  const handleCancelOrder = () => {
    if (eventData && eventData?.is_paid) {
      cancelOrder(order_id, {
        onSuccess: data => {
          refetch();
          Notifier.showNotification({
            title: 'Order canceled successfully.',
            Component: NotifierComponents.Alert,
            componentProps: {
              alertType: 'success',
            },
          });
        },
        onError: error => {
          console.error('Error canceling order:', error);
        },
      });
    } else {
      deleteEventUserStatus(
        {event_id: orderDetails?.event_id || 0, user_id: user?.uid || ''},
        {
          onSuccess: data => {
            refetch();
            Notifier.showNotification({
              title: 'Order canceled successfully.',
              Component: NotifierComponents.Alert,
              componentProps: {
                alertType: 'success',
              },
            });
          },
          onError: error => {
            console.error('Error canceling order:', error);
          },
        },
      );
    }
  };

  useEffect(() => {
    const qrData = {
      eventId,
    };
    setQrValue(JSON.stringify(qrData));
  }, [eventId]);

  const handleAddToWallet = () => {
    Alert.alert('Adding ticket to wallet');
  };

  // Add to Calendar functionality
  const addEventToCalendar = async (title: any, startDate: any, endDate: any, description: any, location: any) => {
    const now = new Date();
    const startDateEvent = new Date(startDate);
    const effectiveStartDate = startDateEvent < now ? now : startDateEvent;

    try {
      const eventConfig = {
        title,
        startDate: effectiveStartDate.toISOString(),
        endDate: new Date(endDate).toISOString(),
        location,
        notes: description,
      };

      const result = await AddCalendarEvent.presentEventCreatingDialog(eventConfig);

      if (result.action === 'SAVED') {
        Alert.alert('Success', 'Event added to calendar!');
      } else if (result.action === 'CANCELED') {
        console.log('User cancelled calendar event creation');
      }
    } catch (error) {
      console.error('Error adding event to calendar:', error);
    }
  };

  // Ensure Android Calendar permissions (READ + WRITE)
  const ensureAndroidCalendarPermissions = async (): Promise<boolean> => {
    if (Platform.OS !== 'android') return true;
    try {
      let readStatus = await check(PERMISSIONS.ANDROID.READ_CALENDAR);
      let writeStatus = await check(PERMISSIONS.ANDROID.WRITE_CALENDAR);

      if (readStatus !== RESULTS.GRANTED) {
        readStatus = await request(PERMISSIONS.ANDROID.READ_CALENDAR);
      }
      if (writeStatus !== RESULTS.GRANTED) {
        writeStatus = await request(PERMISSIONS.ANDROID.WRITE_CALENDAR);
      }

      return readStatus === RESULTS.GRANTED && writeStatus === RESULTS.GRANTED;
    } catch (e) {
      console.error('Calendar permission check error:', e);
      return false;
    }
  };

  const addCalendarEvent = async (eventConfig: any) => {
    try {
      if (Platform.OS === 'android') {
        const granted = await ensureAndroidCalendarPermissions();
        if (!granted) {
          Alert.alert(
            'Permission required',
            'Calendar permission is needed to add events. You can enable it in Settings.',
            [
              {text: 'Cancel', style: 'cancel'},
              {text: 'Open Settings', onPress: () => openSettings().catch(() => {})},
            ],
          );
          return;
        }
      }
      const result = await RNCalendarEvents.saveEvent(eventConfig.title || 'title', eventConfig);
      if (result) {
        Alert.alert('Success', 'Event added to calendar!');
      }
    } catch (error) {
      console.error('Error adding event to calendar:', error);
      Alert.alert('Error', 'Failed to add event to calendar');
    }
  };

  const addToCalendar = () => {
    if (!eventData) {
      Alert.alert('Error', 'Event data not available');
      return;
    }

    const title = eventData.name || 'Event';
    const startDate = eventData.start_date;
    const endDate = eventData.end_date;
    const description = eventData.description || '';
    const location = eventData.address_name || '';

    if (Platform.OS === 'ios') {
      addEventToCalendar(title, startDate, endDate, description, location);
    } else {
      const eventConfig = {
        title,
        startDate: new Date(startDate).toISOString(),
        endDate: new Date(endDate).toISOString(),
        location,
        notes: description,
      };
      addCalendarEvent(eventConfig);
    }
  };

  const handleTransferBooking = () => {
    setTransferModalVisible(true);
  };

  const handleTransferCancelOptions = () => {
    setTransferCancelOptionsVisible(true);
  };

  const handleTransferOption = () => {
    setTransferCancelOptionsVisible(false);
    setTransferModalVisible(true);
  };

  const handleCancelOption = () => {
    console.log('handleCancelOption called, closing transfer modal and opening cancel modal');
    setTransferCancelOptionsVisible(false);
    // Open the cancel reason modal after a small delay to ensure proper modal transition
    setTimeout(() => {
      console.log('Opening cancel modal');
      setCancelModalVisible(true);
    }, 100);
  };

  const handleTransferSuccess = () => {
    // Refetch order details after successful transfer
    refetch();
    setTransferModalVisible(false);
  };

  // Enhanced Countdown Functions for Cancellation Policy
  const getCancellationStatus = () => {
    if (!eventData?.start_date) {
      return {
        status: 'too_early',
        canCancel: false,
        canRefund: false,
        timeInfo: 'Event date not available',
      };
    }

    const eventDateTime = moment(eventData.start_date);
    const now = moment();
    const hoursUntilEvent = eventDateTime.diff(now, 'hours');
    const daysUntilEvent = eventDateTime.diff(now, 'days');
    const minutesUntilEvent = eventDateTime.diff(now, 'minutes');

    // Event has already started
    if (hoursUntilEvent <= 0) {
      return {
        status: 'event_started',
        canCancel: false,
        canRefund: false,
        timeInfo: 'Event has started',
      };
    }

    // More than 72 hours before event - early cancellation available
    if (hoursUntilEvent > 72) {
      const daysLeft = Math.ceil((hoursUntilEvent - 72) / 24);
      return {
        status: 'too_early',
        canCancel: true,
        canRefund: true,
        timeInfo: `${daysLeft} day${daysLeft !== 1 ? 's' : ''} until cancellation deadline`,
      };
    }

    // Between 48-72 hours before event - can cancel with full refund
    if (hoursUntilEvent > 48) {
      const refundDeadline = eventDateTime.clone().subtract(48, 'hours');
      const countdownToDeadline = formatCountdownStopwatch(refundDeadline);
      return {
        status: 'can_refund',
        canCancel: true,
        canRefund: true,
        timeInfo: countdownToDeadline || '00:00:00',
      };
    }

    // Less than 48 hours before event - can cancel but no refund
    const eventCountdown = formatCountdownStopwatch(eventDateTime);
    return {
      status: 'no_refund',
      canCancel: true,
      canRefund: false,
      timeInfo: eventCountdown || '00:00:00',
    };
  };

  // Format countdown as stopwatch (decreasing time)
  const formatCountdownStopwatch = (targetDateTime: moment.Moment): string => {
    const now = moment();
    const diff = targetDateTime.diff(now);

    if (diff <= 0) {
      return '00:00:00';
    }

    const duration = moment.duration(diff);
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    if (days > 0) {
      // Show days format: "2d 05:30:45"
      return `${days}d ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    } else {
      // Show hours format: "05:30:45"
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  };

  const handleEmailSupport = () => {
    const subject = encodeURIComponent('Support Request');
    const body = encodeURIComponent(
      `
Hi Pyxi Team,

I need assistance with my event booking.

Event Details:
- Event: ${eventData?.name || 'N/A'}
- Date: ${eventData?.start_date ? moment(eventData.start_date).format('MMMM Do YYYY, h:mm A') : 'N/A'}
- Order ID: ${order_id}

Please assist me with my inquiry.

Best regards,
${userAccount?.first_name || ''} ${userAccount?.last_name || ''}
    `.trim(),
    );

    const emailUrl = `mailto:pyxi@pyxidalife.com?subject=${subject}&body=${body}`;

    Linking.canOpenURL(emailUrl).then((supported: boolean) => {
      if (supported) {
        Linking.openURL(emailUrl);
      } else {
        Alert.alert('Email Not Available', 'Please contact pyxi@pyxidalife.com directly for support.');
      }
    });
  };

  const handleCancelBooking = () => {
    console.log('handleCancelBooking called');
    // Close the transfer/cancel options modal if it's open
    if (transferCancelOptionsVisible) {
      setTransferCancelOptionsVisible(false);
      // Add delay to ensure proper modal transition
      setTimeout(() => {
        setCancelModalVisible(true);
      }, 100);
    } else {
      // Direct cancel booking - no delay needed
      setCancelModalVisible(true);
    }
  };

  const handleCancelModalClose = () => {
    setCancelReason('');
    setCancelModalVisible(false);
  };

  const handleCancelWithReason = () => {
    if (!cancelReason.trim()) {
      Alert.alert('Cancellation Reason Required', 'Please provide a reason for cancellation.');
      return;
    }

    const subject = encodeURIComponent('Booking Cancellation Request');
    const body = encodeURIComponent(
      `
Hi Pyxi Team,

I would like to cancel my event booking.

Event Details:
- Event: ${eventData?.name || 'N/A'}
- Date: ${eventData?.start_date ? moment(eventData.start_date).format('MMMM Do YYYY, h:mm A') : 'N/A'}
- Order ID: ${order_id}

Cancellation Reason:
${cancelReason.trim()}

Please process my cancellation request.

Best regards,
${userAccount?.first_name || ''} ${userAccount?.last_name || ''}
    `.trim(),
    );

    const emailUrl = `mailto:pyxi@pyxidalife.com?subject=${subject}&body=${body}`;

    Linking.canOpenURL(emailUrl).then((supported: boolean) => {
      if (supported) {
        Linking.openURL(emailUrl);
        // Close the modal after sending email
        handleCancelModalClose();
      } else {
        Alert.alert('Action no longer available on the app, please contact pyxi@pyxidalife.com directly.');
      }
    });
  };
  
  // Functions to handle attendance status changes
  const handleSetStatus = (status: 'on_time' | 'late' | 'not_coming') => {
    if (!order_id) return;
    
    // Update the selected status
    setSelectedStatus(status);
    
    // Call unified API with the new status
    setAttendanceStatus({ 
      order_id, 
      status_type: status 
    });
  };

  // Check if attendance status feature should be available
  const showAttendanceStatus = () => {
    if (!eventData || !orderDetails || orderDetails.status !== 'succeeded') {
      return false;
    }

    // Check if the event is one of the required types
    const validTypes = ['THE_REST_TABLE', 'CULTURAL_EDIT', 'HOUSEWARMING'];
    if (!validTypes.includes(eventData.event_service_type)) {
      return false;
    }

    // Check if the event starts within 24 hours and hasn't started yet
    const now = moment();
    const eventStart = moment(eventData.start_date);
    const hoursUntilEvent = eventStart.diff(now, 'hours');

    return hoursUntilEvent <= 24 && hoursUntilEvent > 0;
  };

  // Set initial attendance status from API data
  useEffect(() => {
    if (attendanceStatusData) {
      if (attendanceStatusData.is_on_time) {
        setSelectedStatus('on_time');
      } else if (attendanceStatusData.is_late) {
        setSelectedStatus('late');
      } else if (attendanceStatusData.is_not_coming) {
        setSelectedStatus('not_coming');
      }
    }
  }, [attendanceStatusData]);

  // Guest invitation functions
  const handleInviteGuest = () => {
    setInviteModalVisible(true);
  };

  const handleShowEmailInviteModal = () => {
    setInviteModalVisible(false);
    setEmailInviteModalVisible(true);
  };

  const handleEmailInvite = async () => {
    if (!inviteEmail || !inviteName) {
      Alert.alert('Error', 'Please enter both name and email');
      return;
    }

    try {
      await inviteGuestViaEmail({orderId: order_id, email: inviteEmail, name: inviteName});
      Alert.alert('Success', `Invitation sent to ${inviteEmail}`);
      setInviteEmail('');
      setInviteName('');
      setEmailInviteModalVisible(false);
      // Refetch order details to update guest list
      refetch();
    } catch (error) {
      Alert.alert('Error', 'Failed to send invitation. Please try again.');
    }
  };

  const handleCancelEmailInvite = () => {
    setInviteEmail('');
    setInviteName('');
    setEmailInviteModalVisible(false);
  };

  const handleLinkInvite = async () => {
    const inviteLink = `https://www.pyxi.ai/dinner-invite.html?order_id=${order_id}`;

    try {
      await Share.share({
        message: `You're invited to join me at ${eventData?.name}! Use this link to confirm your attendance: ${inviteLink}`,
        url: inviteLink,
        title: 'Event Invitation',
      });
      setInviteModalVisible(false);
    } catch (error) {
      console.error('Error sharing invite link:', error);
      Alert.alert('Error', 'Failed to share invitation link');
    }
  };

  const getTotalTickets = () => {
    return orderDetails?.total_tickets || 0;
  };

  const getAvailableGuestSlots = () => {
    const totalTickets = getTotalTickets();
    const guestCount = orderDetails?.guest_uids?.length || 0;
    return totalTickets > 1 ? totalTickets - 1 - guestCount : 0;
  };

  const shouldShowInviteSection = () => {
    // Only show for specific event types
    const validTypes = ['THE_REST_TABLE', 'CULTURAL_EDIT', 'HOUSEWARMING'];
    if (!eventData || !validTypes.includes(eventData.event_service_type)) {
      return false;
    }

    return getTotalTickets() > 1 && getAvailableGuestSlots() > 0;
  };

  const areAllGuestsConfirmed = () => {
    return guestDetails.length === getTotalTickets() - 1;
  };

  const getGuestStatusMessage = () => {
    const totalGuestsNeeded = getTotalTickets() - 1;
    const confirmedGuests = guestDetails.length; // All guests in the list are confirmed

    if (totalGuestsNeeded === 0) return null;

    if (confirmedGuests === totalGuestsNeeded) {
      return '🎉 All your guests have confirmed their attendance!';
    } else if (guestDetails.length < totalGuestsNeeded) {
      const remainingSlots = totalGuestsNeeded - guestDetails.length;
      return `You need to invite ${remainingSlots} guest${remainingSlots > 1 ? 's' : ''} for this event.`;
    }

    return null;
  };

  // Proactively request calendar permissions on Android (READ + WRITE)
  useEffect(() => {
    if (Platform.OS === 'android') {
      ensureAndroidCalendarPermissions();
    }
  }, []);

  // Real-time countdown updates every second
  useEffect(() => {
    const updateCountdown = () => {
      if (eventData?.start_date) {
        const eventDateTime = moment(eventData.start_date);
        const now = moment();
        const hoursUntilEvent = eventDateTime.diff(now, 'hours');

        // Only show countdown if we're within 72 hours
        if (hoursUntilEvent <= 72 && hoursUntilEvent > 0) {
          setCountdownTime(formatCountdownStopwatch(eventDateTime));

          // Add subtle pulse animation for active countdown
          Animated.sequence([
            Animated.timing(pulseAnim, {
              toValue: 1.05,
              duration: 500,
              useNativeDriver: true,
            }),
            Animated.timing(pulseAnim, {
              toValue: 1,
              duration: 500,
              useNativeDriver: true,
            }),
          ]).start();
        } else {
          setCountdownTime('');
        }
      }
    };

    // Update immediately
    updateCountdown();

    // Then update every second
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [eventData, pulseAnim]);

  // Animation for highlighted address when event is within 24 hours
  useEffect(() => {
    if (eventData?.start_date) {
      const eventDateTime = moment(eventData.start_date);
      const now = moment();
      const hoursUntilEvent = eventDateTime.diff(now, 'hours');

      // Animate the highlighted address if event is within 24 hours
      if (hoursUntilEvent <= 24 && hoursUntilEvent > 0) {
        const animateAddress = () => {
          Animated.sequence([
            Animated.timing(addressPulseAnim, {
              toValue: 1.08,
              duration: 1500,
              useNativeDriver: true,
            }),
            Animated.timing(addressPulseAnim, {
              toValue: 1,
              duration: 1500,
              useNativeDriver: true,
            }),
          ]).start(() => {
            // Repeat animation
            setTimeout(animateAddress, 2000);
          });
        };

        animateAddress();
      }
    }
  }, [eventData, addressPulseAnim]);

  // Animate rate event card entrance
  useEffect(() => {
    Animated.parallel([
      Animated.timing(rateCardScale, {
        toValue: 1,
        duration: 600,
        useNativeDriver: true,
      }),
      Animated.timing(rateCardOpacity, {
        toValue: 1,
        duration: 600,
        useNativeDriver: true,
      }),
    ]).start();
  }, []);

  const goBackHandler = () => {
    navigation.goBack();
  };

  const handleViewCancellationPolicy = () => {
    const url = 'https://www.pyxi.ai/terms-and-conditions';
    Linking.canOpenURL(url).then((supported: boolean) => {
      if (supported) {
        Linking.openURL(url);
      } else {
        Alert.alert('Error', 'Unable to open the terms and conditions page.');
      }
    });
  };

  const calculateTotal = (): number => {
    return orderDetails?.total_amount || 0;
  };

  const getCurrencySymbol = (currencyCode: string): string => {
    const currencySymbols: { [key: string]: string } = {
      'GBP': '£',
      'USD': '$',
      'EUR': '€',
      'INR': '₹',
      'JPY': '¥',
      'AUD': 'A$',
      'CAD': 'C$',
      'CHF': 'CHF',
      'CNY': '¥',
      'SEK': 'kr',
      'NZD': 'NZ$',
      'SGD': 'S$',
      'HKD': 'HK$',
      'NOK': 'kr',
      'KRW': '₩',
      'MXN': '$',
      'ZAR': 'R',
      'BRL': 'R$',
      'TRY': '₺',
      'AED': 'د.إ',
      'SAR': '﷼',
      'QAR': '﷼',
      'ARS': '$',
      'CLP': '$',
      'COP': '$',
      'PEN': 'S/',
      'THB': '฿',
      'MYR': 'RM',
      'PHP': '₱',
      'IDR': 'Rp',
      'VND': '₫',
      'PKR': '₨',
      'BDT': '৳',
    };
    return currencySymbols[currencyCode] || currencyCode;
  };

  const getStatusColor = (status: string) => {
    if (status == 'succeeded') {
      return colors.statusGreen;
    } else if (status == 'canceled') {
      return colors.error;
    } else {
      return colors.warning;
    }
  };

  const getPaymentInfo = (status: string, is_paid?: boolean) => {
    console.log(status, 'statusstatus');
    
    if (!is_paid) {
      if (status === 'succeeded') {
        return {
          title: 'Booking Successful!',
          description: 'Your booking has been successfully placed. We look forward to seeing you at the event!',
        };
      } else if (status === 'canceled') {
        return {
          title: 'Booking Canceled',
          description: 'Your booking has been canceled. If this was a mistake, please contact support.',
        };
      } else if (status === 'failed') {
        return {
          title: 'Booking Failed',
          description: 'Your booking could not be completed. Please try again or contact support.',
        };
      } else if (status === 'refunded') {
        return {
          title: 'Booking Refunded',
          description: 'Your booking has been canceled and refunded. If you have questions, please contact support.',
        };
      } else {
        return {
          title: 'Booking Pending',
          description: 'Your booking is currently being processed. You will receive a confirmation shortly.',
        };
      }
    }

    if (status === 'succeeded') {
      return {
        title: 'Booking Successful!',
        description: 'Thank you for your booking. We look forward to seeing you at the event!',
      };
    } else if (status === 'canceled') {
      return {
        title: 'Booking Canceled',
        description: 'Your booking has been canceled. Please try again or contact support for assistance.',
      };
    } else if (status === 'failed') {
      return {
        title: 'Booking Failed',
        description: 'Your booking could not be completed. Please check your payment details and try again.',
      };
    } else if (status === 'refunded') {
      return {
        title: 'Booking Refunded',
        description: 'Your booking has been successfully refunded. If you have any questions, please contact support.',
      };
    } else {
      return {
        title: 'Booking Pending',
        description: 'Your booking is currently being processed. You will receive a confirmation shortly.',
      };
    }
  };
  const handleNext = () => {
    if (
      orderDetails &&
      orderDetails.order_details &&
      currentIndex < orderDetails.order_details.length - 1 &&
      flatListRef.current
    ) {
      const nextIndex = currentIndex + 1;
      const offset = nextIndex * screenWidth;
      flatListRef.current.scrollToOffset({offset, animated: true});
      setCurrentIndex(nextIndex);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0 && flatListRef.current) {
      const prevIndex = currentIndex - 1;
      const offset = prevIndex * screenWidth;
      flatListRef.current.scrollToOffset({offset, animated: true});
      setCurrentIndex(prevIndex);
    }
  };

  const renderTicket = ({item, index}: any) => (
    <View style={[styles.ticketContainer, {width: screenWidth}]}>
      <Text style={styles.ticketTitle}>Ticket {index + 1}</Text>
      <QRCodeGenerator
        qrCode={item.qr_codes && item.qr_codes.length > 0 ? item.qr_codes[0] : undefined}
        user={userAccount}
        event={eventData}
        isBigQr={true}
      />
    </View>
  );

  const isEventEnded = () => {
    if (!eventData) {
      return false;
    }

    if (moment(eventData.start_date).isBefore(moment())) {
      return true;
    }

    return false;
  };

  const onRateEventClick = () => {
    // Trigger press animation
    Animated.sequence([
      Animated.timing(rateButtonAnim, {
        toValue: 0.94,
        duration: 120,
        useNativeDriver: true,
      }),
      Animated.timing(rateButtonAnim, {
        toValue: 1,
        duration: 120,
        useNativeDriver: true,
      }),
    ]).start();
    
    if (eventData) {
      setTimeout(() => {
        navigation.navigate(SCREENS.RATE_EVENT, {event: eventData});
      }, 240);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <ThemedStatusBar />

      <ModernHeader
        title={orderDetails?.status === 'succeeded' ? 'Payment Successful' : 'Payment Status'}
        subtitle={eventData?.name}
        onBackPress={goBackHandler}
        variant="elevated"
      />
      <ScrollView>
        {/* Guest Management Section */}
        {orderDetails?.status === 'succeeded' && (shouldShowInviteSection() || guestDetails.length > 0) && (
          <View style={styles.guestSection}>
            <View style={styles.guestSectionHeader}>
              <MaterialIcons name="people" size={20} color={colors.primary} />
              <Text style={styles.guestSectionTitle}>
                Your Guests ({guestDetails.length}/{getTotalTickets() - 1})
              </Text>
            </View>

            {/* Existing Guests */}
            {guestDetailsLoading ? (
              <View style={{paddingHorizontal: 16, paddingVertical: 20, alignItems: 'center'}}>
                <ActivityIndicator size="small" color={colors.primary} />
                <Text style={{marginTop: 8, color: colors.textSecondary}}>Loading guest details...</Text>
              </View>
            ) : (
              guestDetails.map((guest, index) => (
                <View key={`guest-${guest.email}-${index}`} style={styles.guestItem}>
                  <MaterialIcons name="person" size={24} color={colors.primary} />
                  <View style={styles.guestInfo}>
                    <Text style={styles.guestName}>
                      {guest.first_name} {guest.last_name}
                    </Text>
                    <Text style={styles.guestEmail}>{guest.email}</Text>
                  </View>
                  <Text style={[styles.guestStatus, styles.confirmedStatus]}>Confirmed</Text>
                </View>
              ))
            )}

            {/* Invite More Guests Button */}
            {shouldShowInviteSection() && (
              <TouchableOpacity style={styles.inviteButton} onPress={handleInviteGuest}>
                <MaterialIcons name="person-add" size={20} color={colors.white} />
                <Text style={styles.inviteButtonText}>
                  Invite Guest ({getAvailableGuestSlots()} slot{getAvailableGuestSlots() > 1 ? 's' : ''} remaining)
                </Text>
              </TouchableOpacity>
            )}

            {/* Guest Status Message */}
            {getGuestStatusMessage() && (
              <View style={styles.guestMessage}>
                <Text style={styles.guestMessageText}>{getGuestStatusMessage()}</Text>
              </View>
            )}
          </View>
        )}

        <View style={styles.eventDetails}>
          <View style={styles.eventCardWrapper}>
            <Image
              source={{ uri: eventData?.image_url }}
              style={[
                styles.eventImage,
                {
                  borderRadius: 18,
                  marginBottom: 0,
                  minHeight: 160,
                  backgroundColor: colors.surface,
                },
              ]}
            />
            <View style={[styles.eventInfo, { paddingBottom: 8 }]}> 
            <Text style={[styles.eventTitle, { fontSize: 20, marginBottom: 10 }]} numberOfLines={2}>
              {eventData?.name}
            </Text>
          
              <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 12, paddingBottom: 12, borderBottomWidth: 1, borderBottomColor: colors.border + '20' }}>
                <View style={{ width: 36, height: 36, borderRadius: 9, backgroundColor: colors.primary + '12', alignItems: 'center', justifyContent: 'center', marginRight: 10 }}>
                  <MaterialIcons name="location-on" size={18} color={colors.primary} />
                </View>
                <Text style={[styles.dateTitle, { fontSize: 14, fontWeight: '600', flex: 1 }]}> {(eventData?.event_service_type == 'THE_REST_TABLE'
                  ? eventData?.address_name
                  : eventData?.coord_address) || 'Location TBA'}</Text>
              </View>

            <View
              style={[
                styles.dateContainer,
                {
                  backgroundColor: colors.surface,
                  borderRadius: 10,
                  marginBottom: 0,
                  paddingVertical: 12,
                },
              ]}
            >
              <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                <View style={{ width: 36, height: 36, borderRadius: 9, backgroundColor: colors.primary + '12', alignItems: 'center', justifyContent: 'center', marginRight: 10 }}>
                  <MaterialIcons name="event" size={18} color={colors.primary} />
                </View>
                <Text style={[styles.dateTitle, { fontSize: 15, fontWeight: '700' }]}>Event Schedule</Text>
              </View>
              <View style={{flexDirection: 'row', alignItems: 'center', marginBottom: 4, marginTop: 4}}>
                <Text style={[styles.dateLabel, {fontWeight: '600', color: colors.textSecondary, width: 60}]}>
                  Start:
                </Text>
                <Text style={[styles.dateText, {fontSize: 15, color: colors.textPrimary, fontWeight: '500'}]}>
                  {eventData?.start_date ? moment(eventData?.start_date).format('dddd, MMMM D, YYYY • h:mm A') : ''}
                </Text>
              </View>
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <Text style={[styles.dateLabel, {fontWeight: '600', color: colors.textSecondary, width: 60}]}>
                  End:
                </Text>
                <Text style={[styles.dateText, {fontSize: 15, color: colors.textPrimary, fontWeight: '500'}]}>
                  {eventData?.end_date ? moment(eventData?.end_date).format('dddd, MMMM D, YYYY • h:mm A') : ''}
                </Text>
              </View>
              <TouchableOpacity
                style={[
                  styles.calendarButton,
                  {
                    marginTop: 12,
                    alignSelf: 'flex-start',
                    borderRadius: 6,
                    paddingHorizontal: 14,
                    paddingVertical: 8,
                    backgroundColor: colors.primary + '10',
                  },
                ]}
                onPress={addToCalendar}
                activeOpacity={0.7}>
                <MaterialIcons name="calendar-today" size={18} color={colors.primary} style={{marginRight: 6}} />
                <Text style={[styles.calendarButtonText, {fontWeight: '600', fontSize: 14}]}>Add to Calendar</Text>
              </TouchableOpacity>
            </View>
            </View>
          </View>
        </View>

        {/* Address Section - Enhanced for event timing (only for THE_REST_TABLE or CULTURAL_EDIT) */}
        {eventData?.start_date &&
          (eventData?.event_service_type === 'THE_REST_TABLE' || eventData?.event_service_type === 'CULTURAL_EDIT') &&
          (() => {
            const eventDateTime = moment(eventData.start_date);
            const eventEndDateTime = moment(eventData.end_date);
            const now = moment();
            const hoursUntilEvent = eventDateTime.diff(now, 'hours');
            const hoursUntilEventEnd = eventEndDateTime.diff(now, 'hours');

            if (hoursUntilEventEnd < 0) {
              return (
                <View style={styles.addressSection}>
                  <View style={styles.addressContainer}>
                    <View style={styles.addressHeader}>
                      <MaterialIcons
                        name="location-on"
                        size={24}
                        color={colors.textSecondary}
                        style={styles.addressIcon}
                      />
                      <Text style={styles.addressTitle}>Event Location</Text>
                    </View>
                    <Text style={styles.addressText}>
                      Event was at{' '}
                      {finalAddressData?.final_address
                        ? finalAddressData.final_address
                        : eventData?.address_name || 'N/A'}
                    </Text>
                  </View>
                </View>
              );
            }

            if (hoursUntilEvent <= 24 && hoursUntilEventEnd > 0 && finalAddressData?.final_address) {
              return (
                <Animated.View style={[styles.addressSection, {transform: [{scale: addressPulseAnim}]}]}>
                  <View style={styles.addressContainer}>
                    <View style={styles.addressHeader}>
                      <View>
                        <MaterialIcons name="location-on" size={24} color={colors.primary} style={styles.addressIcon} />
                      </View>
                      <Text style={styles.addressTitle}>Event Location</Text>
                    </View>
                    <Text style={styles.addressText}>{finalAddressData.final_address}</Text>
                    <View style={styles.addressAlert}>
                      <View>
                        <MaterialIcons name="access-time" size={18} color={colors.warning} />
                      </View>
                      <Text style={styles.addressAlertText}>
                        {hoursUntilEvent > 0
                          ? `Starting in ${hoursUntilEvent} hour${hoursUntilEvent !== 1 ? 's' : ''}`
                          : 'Event has started'}
                      </Text>
                    </View>
                  </View>
                </Animated.View>
              );
            }

            // Show message if more than 24 hours before event
            return (
              <View style={styles.addressSection}>
                <View style={styles.addressContainer}>
                  <View style={styles.addressHeader}>
                    <MaterialIcons
                      name="location-on"
                      size={24}
                      color={colors.textSecondary}
                      style={styles.addressIcon}
                    />
                    <Text style={styles.addressTitle}>Event Location</Text>
                  </View>
                  <Text style={styles.addressText}>
                    The exact location will be available 24 hours before the event starts.
                  </Text>
                </View>
              </View>
            );
          })()}

        <View style={styles.ticketList}>
          <View style={styles.ticketListHeader}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              <MaterialIcons name="confirmation-number" size={20} color={colors.primary} style={{marginRight: 8}} />
              <Text style={styles.ticketListHeaderText}>
                {eventData?.is_paid ? 'Ticket Summary' : 'Booking Details'}
              </Text>
            </View>
          </View>
          <View style={styles.ticketSection}>
            {eventData?.is_paid ? (
              <>
                {orderDetails?.order_details?.map((ticket, index) => (
                  <View key={`ticket-${ticket.name}-${index}`} style={styles.ticketItem}>
                    <View style={styles.ticketItemLeft}>
                      <Text style={styles.ticketType}>{ticket.name}</Text>
                      <Text style={styles.ticketQuantity}>
                        {`${getCurrencySymbol(ticket.currency)} ${ticket.discounted_price} × ${ticket.count}`}
                      </Text>
                    </View>
                    <Text style={styles.ticketPrice}>
                      {getCurrencySymbol(ticket.currency)} {ticket.discounted_price * (ticket.count || 1)}
                    </Text>
                  </View>
                ))}
                <View style={styles.totalSection}>
                  <View style={styles.totalRow}>
                    <Text style={styles.totalLabel}>Total Amount</Text>
                    <Text style={styles.totalAmount}>
                      {getCurrencySymbol(orderDetails?.currency || '')} {calculateTotal()}
                    </Text>
                  </View>
                </View>
              </>
            ) : (
              <View style={styles.ticketItem}>
                <Text style={styles.ticketType}>Number of Tickets</Text>
                <Text style={styles.ticketPrice}>{orderDetails?.order_details.length}</Text>
              </View>
            )}
          </View>
        </View>

        {qrValue && orderDetails?.status && (
          <View style={styles.statusContainer}>
            <Text style={styles.statusIcon}>
              <Text>
                {orderDetails.status === 'succeeded'
                  ? '✅'
                  : orderDetails.status === 'failed'
                    ? '❌'
                    : orderDetails.status === 'canceled'
                      ? '🚫'
                      : '⏳'}
              </Text>
            </Text>
            <Text style={styles.statusHeader}>{getPaymentInfo(orderDetails.status, eventData?.is_paid).title}</Text>
            <Text style={styles.statusDescription}>
              {getPaymentInfo(orderDetails.status, eventData?.is_paid).description}
            </Text>
            <View style={styles.statusBadge}>
              <MaterialIcons
                name={orderDetails.status === 'succeeded' ? 'check-circle' : 'info'}
                size={16}
                color={getStatusColor(orderDetails.status)}
              />
              <Text style={[styles.statusBadgeText, {color: getStatusColor(orderDetails.status)}]}>
                {orderDetails.status.toUpperCase()}
              </Text>
            </View>
          </View>
        )}

        {/* Attendance Status Section */}
        {orderDetails?.status === 'succeeded' && showAttendanceStatus() && (
          <View style={styles.attendanceContainer}>
            <View style={styles.attendanceHeader}>
              <MaterialIcons name="access-time" size={20} color={colors.primary} />
              <Text style={styles.attendanceTitle}>Attendance Status</Text>
            </View>
            <View style={styles.attendanceContent}>
              <Text style={styles.attendanceDescription}>
                Let the host and other attendees know about your attendance plans:
              </Text>

              {/* Current Status (if any) */}
              {selectedStatus && (
                <View
                  style={[
                    styles.attendanceStatusBadge,
                    {
                      backgroundColor:
                        selectedStatus === 'on_time'
                          ? colors.statusGreen + '15'
                          : selectedStatus === 'late'
                            ? colors.warning + '15'
                            : colors.error + '15',
                    },
                  ]}>
                  <MaterialIcons
                    name={
                      selectedStatus === 'on_time'
                        ? 'check-circle'
                        : selectedStatus === 'late'
                          ? 'watch-later'
                          : 'cancel'
                    }
                    size={16}
                    color={
                      selectedStatus === 'on_time'
                        ? colors.statusGreen
                        : selectedStatus === 'late'
                          ? colors.warning
                          : colors.error
                    }
                  />
                  <Text
                    style={[
                      styles.attendanceStatusBadgeText,
                      {
                        color:
                          selectedStatus === 'on_time'
                            ? colors.statusGreen
                            : selectedStatus === 'late'
                              ? colors.warning
                              : colors.error,
                      },
                    ]}>
                    {selectedStatus === 'on_time'
                      ? "I'll be on time"
                      : selectedStatus === 'late'
                        ? "I'll be late"
                        : "I'm not coming"}
                  </Text>
                </View>
              )}

              {/* On Time Button */}
              <TouchableOpacity
                style={[
                  styles.attendanceButton,
                  selectedStatus === 'on_time' && styles.attendanceButtonActive,
                  selectedStatus === 'on_time' && styles.attendanceButtonOnTime,
                  { marginTop: 12, opacity: (attendanceLoading || selectedStatus === 'on_time') ? 0.5 : 1 }
                ]}
                onPress={() => handleSetStatus('on_time')}
                activeOpacity={0.7}
                disabled={attendanceLoading || selectedStatus === 'on_time'}
              >
                <MaterialIcons 
                  name="check-circle" 
                  size={22} 
                  color={colors.statusGreen} 
                />
                <Text style={[
                  styles.attendanceButtonText,
                  selectedStatus === 'on_time' && styles.attendanceButtonTextActive,
                  { color: colors.statusGreen }
                ]}>
                  I'll be on time
                </Text>
              </TouchableOpacity>

              {/* Late Button */}
              <TouchableOpacity
                style={[
                  styles.attendanceButton,
                  selectedStatus === 'late' && styles.attendanceButtonActive,
                  selectedStatus === 'late' && styles.attendanceButtonLate,
                  { marginTop: 8, opacity: (attendanceLoading || selectedStatus === 'late') ? 0.5 : 1 }
                ]}
                onPress={() => handleSetStatus('late')}
                activeOpacity={0.7}
                disabled={attendanceLoading || selectedStatus === 'late'}
              >
                <MaterialIcons 
                  name="watch-later" 
                  size={22} 
                  color={colors.warning}
                />
                <Text style={[
                  styles.attendanceButtonText,
                  selectedStatus === 'late' && styles.attendanceButtonTextActive,
                  { color: colors.warning }
                ]}>
                  I'll be late
                </Text>
              </TouchableOpacity>

              {/* Not Coming Button */}
              <TouchableOpacity
                style={[
                  styles.attendanceButton,
                  selectedStatus === 'not_coming' && styles.attendanceButtonActive,
                  selectedStatus === 'not_coming' && styles.attendanceButtonNotComing,
                  { marginTop: 8, opacity: (attendanceLoading || selectedStatus === 'not_coming') ? 0.5 : 1 }
                ]}
                onPress={() => handleSetStatus('not_coming')}
                activeOpacity={0.7}
                disabled={attendanceLoading || selectedStatus === 'not_coming'}
              >
                <MaterialIcons 
                  name="cancel" 
                  size={22} 
                  color={colors.error}
                />
                <Text style={[
                  styles.attendanceButtonText,
                  selectedStatus === 'not_coming' && styles.attendanceButtonTextActive,
                  { color: colors.error }
                ]}>
                  I'm not coming
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        )}

        {/* Enhanced Cancellation Policy Section */}
        {orderDetails?.status === 'succeeded' && eventData && !isEventEnded() && (
          <View style={[styles.ticketList, {padding: 0}]}>
            {(() => {
              const cancellationStatus = getCancellationStatus();
              let statusIcon = '📅';
              let iconBackgroundColor: string = colors.surface;
              let titleText = 'Booking Information';

              switch (cancellationStatus.status) {
                case 'too_early':
                  statusIcon = '🕒';
                  break;
                case 'can_refund':
                  statusIcon = '⏳';
                  break;
                case 'no_refund':
                  statusIcon = 'ℹ️';
                  break;
                case 'event_started':
                  statusIcon = '🎉';
                  break;
              }

              return (
                <View style={styles.countdownContainer}>
                  <View style={{flexDirection: 'row', alignItems: 'flex-start'}}>
                    <View style={[styles.countdownIconContainer, {backgroundColor: iconBackgroundColor}]}>
                      <Text style={{fontSize: 20}}>
                        <Text>{statusIcon}</Text>
                      </Text>
                    </View>

                    <View style={styles.countdownContent}>
                      <Text style={[styles.countdownTitle, {color: colors.textPrimary, marginBottom: 8}]}>
                        Your Event Details
                      </Text>

                      {cancellationStatus.status === 'too_early' && (
                        <>
                          <Text style={[styles.countdownSubtitle, {color: colors.textSecondary}]}>
                            We're looking forward to seeing you at the event! You have up until 48 hours before the
                            event to transfer or cancel your booking. Please view our terms and conditions for detailed
                            information about our cancellation policy.
                          </Text>
                          <TouchableOpacity
                            style={[styles.cancellationLink, {marginTop: 12}]}
                            onPress={handleViewCancellationPolicy}
                            activeOpacity={0.7}>
                            <Text style={styles.cancellationLinkText}>View Terms & Conditions</Text>
                          </TouchableOpacity>
                        </>
                      )}

                      {cancellationStatus.status === 'can_refund' && (
                        <>
                          <Text style={[styles.countdownSubtitle, {color: colors.textSecondary}]}>
                            Plans can change. You have {cancellationStatus.timeInfo} remaining to transfer or cancel
                            your booking. Remember, you must make changes at least 48 hours before the event starts.
                            Please refer to our terms and conditions for complete details.
                          </Text>
                          <TouchableOpacity
                            style={[styles.cancellationLink, {marginTop: 12}]}
                            onPress={handleViewCancellationPolicy}
                            activeOpacity={0.7}>
                            <Text style={styles.cancellationLinkText}>View Terms & Conditions</Text>
                          </TouchableOpacity>
                        </>
                      )}

                      {cancellationStatus.status === 'no_refund' && (
                        <>
                          <Text style={[styles.countdownSubtitle, {color: colors.textSecondary}]}>
                            Your event starts in {cancellationStatus.timeInfo}. While the refund period has ended,
                            please refer to our terms and conditions for information about other options.
                          </Text>
                          <TouchableOpacity
                            style={[styles.cancellationLink, {marginTop: 12}]}
                            onPress={handleViewCancellationPolicy}
                            activeOpacity={0.7}>
                            <Text style={styles.cancellationLinkText}>View Terms & Conditions</Text>
                          </TouchableOpacity>
                        </>
                      )}

                      {/* Large Stopwatch Display with pulse animation */}
                      {((false && cancellationStatus.status === 'can_refund') ||
                        (false && cancellationStatus.status === 'no_refund')) && (
                        <Animated.Text
                          style={[
                            styles.countdownStopwatchLarge,
                            {
                              color: colors.textPrimary,
                              marginVertical: 8,
                              transform: [{scale: pulseAnim}],
                            },
                          ]}>
                          {cancellationStatus.timeInfo}
                        </Animated.Text>
                      )}
                    </View>
                  </View>
                </View>
              );
            })()}
          </View>
        )}

        {/* Action Buttons Container */}
        {orderDetails?.status == 'succeeded' && eventData && (
          <View style={styles.buttonContainer}>
            {/* Add to Calendar Button */}
            <TouchableOpacity style={styles.primaryButton} onPress={addToCalendar}>
              <MaterialIcons name="event" size={20} color={colors.white} />
              <Text style={[styles.buttonText, styles.primaryButtonText]}>Add to Calendar</Text>
            </TouchableOpacity>

            {/* Transfer/Cancel or Cancel Button - only if event not ended */}
            {!isEventEnded() && (
              (eventData?.event_service_type === 'THE_REST_TABLE' || eventData?.event_service_type === 'CULTURAL_EDIT' || eventData?.event_service_type === 'HOUSEWARMING') ? (
                <TouchableOpacity style={styles.secondaryButton} onPress={handleTransferCancelOptions}>
                  <MaterialIcons name="swap-horiz" size={20} color={colors.textPrimary} />
                  <Text style={[styles.buttonText, styles.secondaryButtonText]}>
                    Transfer to Another Event or Cancel
                  </Text>
                </TouchableOpacity>
              ) : (
                <TouchableOpacity style={styles.dangerButton} onPress={handleCancelBooking}>
                  <MaterialIcons name="cancel" size={20} color={colors.error} />
                  <Text style={[styles.buttonText, styles.dangerButtonText]}>Cancel Booking</Text>
                </TouchableOpacity>
              ))}

            {/* Contact Support Button */}
            <TouchableOpacity style={styles.secondaryButton} onPress={handleEmailSupport}>
              <MaterialIcons name="support-agent" size={20} color={colors.textPrimary} />
              <Text style={[styles.buttonText, styles.secondaryButtonText]}>Contact Support</Text>
            </TouchableOpacity>

            {/* Rate Event Card - Only for past events */}
            {isEventEnded() && (
              <Animated.View 
                style={[
                  styles.rateEventCard,
                  {
                    transform: [{ scale: Animated.add(rateCardScale, Animated.multiply(rateButtonAnim, 0.06)) }],
                    opacity: rateCardOpacity,
                    width: '94%',
                    alignSelf: 'center'
                  },
                ]}
              >
                <TouchableOpacity 
                  onPress={onRateEventClick}
                  activeOpacity={0.7}
                >
                  <View style={styles.rateEventCardContent}>
                    <View style={styles.rateEventIconContainer}>
                      <MaterialIcons name="star" size={32} color={colors.primary} />
                    </View>
                    <View style={styles.rateEventTextContainer}>
                      <Text style={styles.rateEventTitle}>Rate This Event</Text>
                      <Text style={styles.rateEventSubtitle}>Help others discover great events</Text>
                    </View>
                    <MaterialIcons name="chevron-right" size={24} color={colors.primary} style={styles.rateEventArrow} />
                  </View>
                </TouchableOpacity>
              </Animated.View>
            )}
          </View>
        )}

        {orderDetails?.status == 'succeeded' && (
          <View style={styles.ticketSection}>
            <FlatList
              data={orderDetails?.order_details}
              keyExtractor={(item, index) => `ticket-${index}`}
              horizontal
              pagingEnabled
              ref={flatListRef}
              renderItem={renderTicket}
              showsHorizontalScrollIndicator={false}
              onMomentumScrollEnd={e => {
                const offset = e.nativeEvent.contentOffset.x;
                const index = Math.round(offset / screenWidth);
                setCurrentIndex(index);
              }}
            />
            <View style={styles.navigationContainer}>
              <TouchableOpacity
                onPress={handlePrevious}
                disabled={currentIndex === 0}
                style={[styles.navButton, currentIndex === 0 && styles.navButtonDisabled]}>
                <Text style={[styles.navButtonText, currentIndex === 0 && styles.navButtonTextDisabled]}>Previous</Text>
              </TouchableOpacity>
              <Text style={styles.pageIndicator}>
                {currentIndex + 1} / {orderDetails?.order_details.length}
              </Text>
              <TouchableOpacity
                onPress={handleNext}
                disabled={currentIndex === orderDetails.order_details.length - 1}
                style={[
                  styles.navButton,
                  currentIndex === orderDetails.order_details.length - 1 && styles.navButtonDisabled,
                ]}>
                <Text
                  style={[
                    styles.navButtonText,
                    currentIndex === orderDetails.order_details.length - 1 && styles.navButtonTextDisabled,
                  ]}>
                  Next
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        )}
      </ScrollView>
      {(isLoading ||
        cancelLoading ||
        cancelFreeLoading ||
        finalAddressLoading ||
        (eventLoading && !transferModalVisible)) && (
        <View style={styles.loaderContainer}>
          <ActivityIndicator size={'large'} color={colors.eventInfluencer} />
        </View>
      )}

      {/* Transfer Booking Modal */}
      <TransferBookingModal
        visible={transferModalVisible}
        onClose={() => setTransferModalVisible(false)}
        currentEventId={String(eventData?.event_id || '')}
        userEmail={userAccount?.email || ''}
        userId={user?.uid || ''}
        userName={`${userAccount?.first_name || ''} ${userAccount?.last_name || ''}`.trim()}
        onTransferSuccess={handleTransferSuccess}
      />

      {/* Transfer/Cancel Options Modal */}
      <Modal
        visible={transferCancelOptionsVisible}
        transparent
        animationType="fade"
        onRequestClose={() => setTransferCancelOptionsVisible(false)}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>What would you like to do?</Text>
              <Text style={styles.modalSubtitle}>Choose an option for your booking</Text>
            </View>

            <View style={styles.modalOptionsContainer}>
              {/* Transfer Option: only for THE_REST_TABLE or CULTURAL_EDIT */}
              {(eventData?.event_service_type === 'THE_REST_TABLE' || eventData?.event_service_type === 'CULTURAL_EDIT' || eventData?.event_service_type === 'HOUSEWARMING') && (
                (() => {
                  let transferDisabled = false;
                  let transferMessage = '';
                  if (eventData?.start_date) {
                    const eventDateTime = moment(eventData.start_date);
                    const now = moment();
                    const hoursUntilEvent = eventDateTime.diff(now, 'hours');
                    if (hoursUntilEvent < 48) {
                      transferDisabled = true;
                      transferMessage = 'Transfer is not available within 48 hours of the event start time.';
                    }
                  }
                  return (
                    <View>
                      <TouchableOpacity
                        style={[
                          styles.modalOptionButton,
                          styles.modalOptionButtonTransfer,
                          transferDisabled && {opacity: 0.5},
                        ]}
                        onPress={transferDisabled ? undefined : handleTransferOption}
                        activeOpacity={transferDisabled ? 1 : 0.7}
                        disabled={transferDisabled}>
                        <MaterialIcons name="swap-horiz" size={24} color={colors.primary} />
                        <View style={styles.modalOptionContent}>
                          <Text style={styles.modalOptionTitle}>Transfer to Another Event</Text>
                          <Text style={styles.modalOptionDescription}>Move your booking to a different event date</Text>
                        </View>
                        <MaterialIcons
                          name="chevron-right"
                          size={20}
                          color={transferDisabled ? colors.textSecondary : colors.primary}
                        />
                      </TouchableOpacity>
                      {transferDisabled && (
                        <Text
                          style={{color: colors.error, fontSize: 13, marginTop: 6, marginLeft: 8, marginBottom: 10}}>
                          {transferMessage}
                        </Text>
                      )}
                    </View>
                  );
                })())}

              {/* Cancel Option: disabled if less than 48 hours */}
              {(() => {
                let cancelDisabled = false;
                let cancelMessage = '';
                if (eventData?.start_date) {
                  const eventDateTime = moment(eventData.start_date);
                  const now = moment();
                  const hoursUntilEvent = eventDateTime.diff(now, 'hours');
                  if (hoursUntilEvent < 48) {
                    cancelDisabled = true;
                    cancelMessage = 'Cancellation is not available within 48 hours of the event start time.';
                  }
                }
                return (
                  <View>
                    <TouchableOpacity
                      style={[
                        styles.modalOptionButton,
                        styles.modalOptionButtonCancel,
                        cancelDisabled && {opacity: 0.5},
                      ]}
                      onPress={cancelDisabled ? undefined : handleCancelOption}
                      activeOpacity={cancelDisabled ? 1 : 0.7}
                      disabled={cancelDisabled}>
                      <MaterialIcons name="cancel" size={24} color={colors.error} />
                      <View style={styles.modalOptionContent}>
                        <Text style={styles.modalOptionTitle}>Cancel Booking</Text>
                        <Text style={styles.modalOptionDescription}>Cancel this booking</Text>
                      </View>
                      <MaterialIcons name="chevron-right" size={20} color={colors.error} />
                    </TouchableOpacity>
                    {cancelDisabled && (
                      <Text style={{color: colors.error, fontSize: 13, marginTop: 6, marginLeft: 8}}>
                        {cancelMessage}
                      </Text>
                    )}
                  </View>
                );
              })()}
            </View>

            <TouchableOpacity
              style={styles.modalCancelButton}
              onPress={() => setTransferCancelOptionsVisible(false)}
              activeOpacity={0.7}>
              <Text style={styles.modalCancelButtonText}>Close</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {/* No longer needed since we're showing the attendance options directly */}

      {/* Show loading spinner if any attendance status loading or update is in progress */}
      {(attendanceLoading || attendanceStatusLoading) && (
        <View style={styles.loaderContainer}>
          <ActivityIndicator size={'large'} color={colors.eventInfluencer} />
        </View>
      )}

      {/* Guest Invitation Modal */}
      <Modal
        visible={inviteModalVisible}
        transparent
        animationType="fade"
        onRequestClose={() => setInviteModalVisible(false)}>
        <View style={styles.inviteModalOverlay}>
          <View style={styles.inviteModalContainer}>
            <Text style={styles.inviteModalTitle}>Invite Guest</Text>

            <TouchableOpacity style={styles.inviteOptionButton} onPress={handleShowEmailInviteModal}>
              <MaterialIcons name="email" size={24} color={colors.primary} style={styles.inviteOptionIcon} />
              <Text style={styles.inviteOptionText}>Invite via Email</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.inviteOptionButton} onPress={handleLinkInvite}>
              <MaterialIcons name="link" size={24} color={colors.primary} style={styles.inviteOptionIcon} />
              <Text style={styles.inviteOptionText}>Share Invitation Link</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.modalCancelButton} onPress={() => setInviteModalVisible(false)}>
              <Text style={styles.modalCancelButtonText}>Cancel</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {/* Email Invitation Modal */}
      <Modal
        visible={emailInviteModalVisible}
        transparent
        animationType="fade"
        onRequestClose={handleCancelEmailInvite}>
        <View style={styles.inviteModalOverlay}>
          <View style={styles.emailInviteModal}>
            <Text style={styles.emailInviteTitle}>Invite Guest via Email</Text>

            <Text style={styles.inputLabel}>Guest Name</Text>
            <TextInput
              style={styles.textInput}
              placeholder="Enter guest's full name"
              value={inviteName}
              onChangeText={setInviteName}
              autoCapitalize="words"
              returnKeyType="next"
            />

            <Text style={styles.inputLabel}>Email Address</Text>
            <TextInput
              style={styles.textInput}
              placeholder="Enter guest's email"
              value={inviteEmail}
              onChangeText={setInviteEmail}
              keyboardType="email-address"
              autoCapitalize="none"
              returnKeyType="send"
              onSubmitEditing={handleEmailInvite}
            />

            <TouchableOpacity
              style={[styles.sendInviteButton, isInviting && {opacity: 0.7}]}
              onPress={handleEmailInvite}
              disabled={isInviting || !inviteName || !inviteEmail}>
              {isInviting ? (
                <ActivityIndicator color={colors.white} />
              ) : (
                <Text style={styles.sendInviteButtonText}>Send Invitation</Text>
              )}
            </TouchableOpacity>

            <TouchableOpacity style={styles.cancelInviteButton} onPress={handleCancelEmailInvite} disabled={isInviting}>
              <Text style={styles.cancelInviteButtonText}>Cancel</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {/* Cancel Booking Reason Modal */}
      <Modal
        visible={cancelModalVisible}
        transparent
        animationType="fade"
        onRequestClose={handleCancelModalClose}
      >
        <View style={styles.inviteModalOverlay}>
          <View style={styles.emailInviteModal}>
            <Text style={styles.emailInviteTitle}>Cancel Booking</Text>
            
            <Text style={styles.inputLabel}>Please tell us why you're canceling:</Text>
            <TextInput
              style={[styles.textInput, { height: 100, textAlignVertical: 'top' }]}
              placeholder="Enter your reason for cancellation..."
              value={cancelReason}
              onChangeText={setCancelReason}
              multiline={true}
              numberOfLines={4}
              returnKeyType="default"
            />
            
            <TouchableOpacity 
              style={[styles.sendInviteButton, { backgroundColor: colors.error }, (!cancelReason.trim()) && { opacity: 0.5 }]}
              onPress={handleCancelWithReason}
              disabled={!cancelReason.trim()}
            >
              <Text style={styles.sendInviteButtonText}>Send Cancellation Request</Text>
            </TouchableOpacity>
            
            <TouchableOpacity 
              style={styles.cancelInviteButton}
              onPress={handleCancelModalClose}
            >
              <Text style={styles.cancelInviteButtonText}>Cancel</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

export default PaymentSuccess;
